'use client';

import { useContext } from 'react';
import type { Tokens } from '../tokens/types';
import { ThemeContext } from './ThemeContext';

/**
 * Read the active design tokens. Components style themselves by reading
 * `t.color.accent`, `t.space[4]`, `t.radius.md`, etc. Switching palette via
 * `usePalette().setPalette(...)` triggers a re-render with new values.
 */
export function useTokens(): Tokens {
  return useContext(ThemeContext).tokens;
}
